<template>
    <slot />
</template>

<script>
    export default {
        name: 'LayoutDefault'
    }
</script>

<style>

</style>